// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"b20f8388","44":"6b506fe7","214":"42be7b99","396":"36a96fce","409":"904757de","517":"089f0d9e","587":"b20550a8","599":"db065e89","650":"6f7f9d69","832":"5dd1737a","861":"dfa2c3f1","947":"8e3fed8a","964":"844f53bd"}[chunkId] + ".chunk.js";
};